import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  isValidCreditOldId,
  normalizeCreditOldId,
} from "./deployCreditQuotas";

export default function DesplegarCuotasModal({
  errorMessage,
  loading,
  onClose,
  onSubmit,
  open,
}) {
  const [oldId, setOldId] = useState("");
  const isValidOldId = isValidCreditOldId(oldId);
  const showValidationError = oldId !== "" && !isValidOldId;

  useEffect(() => {
    if (open) {
      setOldId("");
    }
  }, [open]);

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!loading && isValidOldId) {
      onSubmit(normalizeCreditOldId(oldId));
    }
  };

  return (
    <Dialog
      aria-labelledby="deploy-credit-quotas-dialog-title"
      fullWidth
      maxWidth="sm"
      onClose={handleClose}
      open={open}
    >
      <form noValidate onSubmit={handleSubmit}>
        <DialogTitle id="deploy-credit-quotas-dialog-title">
          Desplegar cuotas
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Ingresa el ID del crédito pendiente que deseas aprobar y desplegar.
          </DialogContentText>
          {errorMessage && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {errorMessage}
            </Alert>
          )}
          <TextField
            autoFocus
            disabled={loading}
            error={showValidationError}
            fullWidth
            helperText={
              showValidationError ? "Ingresa un número entero positivo." : ""
            }
            inputProps={{ inputMode: "numeric" }}
            label="ID del crédito"
            onChange={(event) => setOldId(event.target.value)}
            required
            value={oldId}
          />
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            disabled={loading || !isValidOldId}
            type="submit"
            variant="contained"
          >
            {loading ? (
              <CircularProgress color="inherit" size={18} />
            ) : (
              "Desplegar cuotas"
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
